import { render, staticRenderFns } from "./InventoryAdjustmentComponent.vue?vue&type=template&id=06c98a1d&"
import script from "./InventoryAdjustmentComponent.vue?vue&type=script&lang=js&"
export * from "./InventoryAdjustmentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports